/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Icon, Modal } from '@mairistem/composants';

import { baseUrlApp } from '@/routes';

import ModalEditionRecensement from '../Common/ModalEditionRecensement';

interface AssistantModalFinProps {
  /** Identifiant du recensé */
  identifiant: number;
  /** Nom de famille du recensé */
  nomFamille: string;
  /** Prénom du recensé */
  prenom: string;
  /** Callback appelé lors de la fermeture de la modal */
  onClose: () => void;
  /** Callback appelé pour réinitialiser l'assistant */
  onReset?: () => void;
}

const AssistantModalFin = (props: AssistantModalFinProps) => {
  const { identifiant, nomFamille, prenom, onClose, onReset } = props;

  const [editionOpen, setEditionOpen] = React.useState<boolean>(false);

  const accueilPath = baseUrlApp;
  const newRecensePath = `${baseUrlApp}recenses/${identifiant}`;

  return (
    <>
      <Modal open size="tiny">
        <Modal.Header content="Fin de la création du recensé" />
        <Modal.Content
          // @ts-expect-error
          style={{
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <p>
            La création du recensé{' '}
            <b>
              {_.toUpper(nomFamille)} {_.capitalize(prenom)}
            </b>{' '}
            est maintenant terminée.
          </p>
          <p>Que souhaitez-vous faire ?</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
            <Button
              fluid
              data-testid="assistant-modal-fin-documents"
              icon={<Icon name="print" />}
              content="Editer les documents de recensement"
              onClick={() => {
                setEditionOpen(true);
              }}
            />
            <Button
              fluid
              data-testid="assistant-modal-fin-fiche"
              as={Link}
              to={newRecensePath}
              icon={<Icon name="file alternate outline" />}
              content="Se rendre sur la fiche du recensé"
              onClick={onClose}
            />
            <Button
              fluid
              data-testid="assistant-modal-fin-nouveau"
              icon={<Icon name="add user" />}
              content="Créer un nouveau recensé"
              onClick={onReset}
            />
            <Button
              fluid
              data-testid="assistant-modal-fin-accueil"
              as={Link}
              to={accueilPath}
              icon={<Icon name="home" />}
              content="Revenir à l'accueil"
              onClick={onClose}
            />
          </div>
        </Modal.Content>
      </Modal>
      {editionOpen && (
        <ModalEditionRecensement
          identifiant={identifiant}
          nomFamille={nomFamille}
          prenom={prenom}
          onClose={() => setEditionOpen(false)}
        />
      )}
    </>
  );
};

export default AssistantModalFin;
